import React from 'react';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

const DateRangeFilter = ({ value, onChange, placeholder }) => {
  return (
    <RangePicker
      className="w-full rounded-lg border-gray-300 shadow-sm"
      format="YYYY-MM-DD"
      placeholder={['Start Date', 'End Date']}
      value={value}
      onChange={onChange}
      allowClear={true}
    />
  );
};

export default DateRangeFilter;